export default function changeEmailReducer(account, action) {
  switch (action.type) {
    case "set":
      return action.value;

    default:
      return { ...account, [action.type]: action.value };
  }
}
